<div class="content">
  <automata-automation-replacement-chips
    label="COMMON.FIELD"
    [dataService]="selectorService"
    [formControl]="fieldIdControl"
    [isRequired]="true"
    [multiple]="false"
    [supportDataPassing]="false"
    (finishedInitialLoading)="finishedLoadingSelector()"
    [extraData]="{ objectType: 'product', supportedFieldTypes: supportedAuxiliaryDataTypes }"
  ></automata-automation-replacement-chips>
</div>
